import React, {useRef} from 'react'
import PropTypes from 'prop-types'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useProducts} from '@salesforce/commerce-sdk-react'
import ProductScroller from '../../../product-scroller'
import {useGlobaleContext} from '../../../../contexts/globale'
import {SELECTED_ATTRIBUTES_WIDGET_PRODUCTS} from '../../../../constants'
import {isServer} from '@salesforce/retail-react-app/app/utils/utils'
import useIntersectionObserver from '@salesforce/retail-react-app/app/hooks/use-intersection-observer'

export const Recommendations = ({
    title,
    titleColor = 'black',
    titleTag = 'h2',
    dataLayerLoaded = true,
    titleFontFamily,
    analyticsProps = {},
    ...rest
}) => {
    const selectedAttributes = SELECTED_ATTRIBUTES_WIDGET_PRODUCTS
    const productIds = []
    const {countryISO, currencyCode} = useGlobaleContext()
    const recommendationRef = useRef(null)
    const isNearViewport = useIntersectionObserver(recommendationRef, {
        useOnce: true,
        rootMargin: '600px 0px'
    })
    let index = 1
    while (`product${index}` in rest) {
        productIds.push(rest[`product${index}`])
        delete rest[`product${index}`] // Avoid modifying rest if unnecessary
        index++
    }
    const enabledRecommendations = Boolean(productIds.length) && !isServer && isNearViewport
    const {data: products, isLoading} = useProducts(
        {
            parameters: {
                ids: productIds.join(','),
                expand: ['availability', 'links', 'promotions', 'images', 'prices', 'variations'],
                select: selectedAttributes,
                perPricebook: true,
                allVariationProperties: true,
                allImages: true,
                c_selectedCountry: countryISO,
                c_selectedCurrency: currencyCode
            }
        },
        {
            enabled: enabledRecommendations
        }
    )

    if (productIds.length === 0) {
        return null
    }

    const trackingProps = {
        component_id: analyticsProps?.componentType || rest.typeId,
        component_name: title || analyticsProps?.componentName || rest.name || rest.typeId
    }

    return (
        <Box ref={recommendationRef}>
            <ProductScroller
                title={title}
                titleFontFamily={titleFontFamily}
                titleColor={titleColor === 'black' ? 'black' : titleColor}
                titleTag={titleTag}
                dataLayerLoaded={dataLayerLoaded}
                products={products?.data}
                isLoading={!isNearViewport || isLoading}
                enableFavourite={true}
                hideArrows={false}
                showImageSlider={true}
                sliderGroup="product"
                analyticsProps={trackingProps}
                deferProductRendering={true}
            />
        </Box>
    )
}

Recommendations.propTypes = {
    title: PropTypes.string,
    titleColor: PropTypes.string,
    dataLayerLoaded: PropTypes.bool,
    titleFontFamily: PropTypes.string,
    titleTag: PropTypes.string,
    products: PropTypes.arrayOf(PropTypes.object),
    analyticsProps: PropTypes.object
}

export default Recommendations
